import { cn } from "../../../util/cn";

interface EmojiFlagTextProps {
  children: any;
  className?: string;
}

function EmojiFlagText({ children, className }: EmojiFlagTextProps) {
  return (
    <span className={cn("emoji-flag-polyfill-text", className)}>{children}</span>
  );
}

export default EmojiFlagText;
